<template>
    <div>
        <div class="leads-profile-details" v-if="current_lead">
            <AssignLeadsToModalVue :assign_lead.sync="modals.assign_lead"  :lead_data="lead_data" @closeAssignToModal="toggleAssignModal" />
            <base-header class="pb-6">
                <b-row align-v="center" class="py-2">
                    <b-col md="3" lg="6" cols="auto">
                        <router-link :to="'/leadsListings' + '?page=' + listing_current_page" class="text-primary">
                            <b-icon icon="chevron-left"></b-icon>
                            Leads Profile
                        </router-link>
                    </b-col>
                    <b-col md="9" lg="6" cols="auto" class="text-right ">
                        <b-button-group class="btn-group-header mx-2">
                            <b-button size="sm" variant="light" class="btn-incharge" @click="toggleAssignModal(current_lead)" :disabled="!checkIsCorporateSubscription()">Assigned To</b-button>
                            <!-- <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-if="current_lead.staff">{{ current_lead.staff.name }}</b-button> -->
                            <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-if="current_lead.staff">{{ current_lead.assign_detail ? current_lead.assign_detail.name : "-"  }}</b-button>
                            <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled v-else>—</b-button>
                        </b-button-group>
                        <b-button size="sm" v-show="backButton" variant="primary" icon @click="close()">
                            <span class="btn-inner--text">Back / Close</span>
                        </b-button>
                    </b-col>
                </b-row>
            </base-header>
            <b-container fluid class="mt--6">
                <b-row>
                    <b-col cols="12" lg="3">
                        <!-- LEADS BIODATA COMPONENT -->
                        <leads-biodata :lead.sync="current_lead"></leads-biodata>
                        <LeadLookingFor :lead.sync="current_lead"/>
                        <!-- MEETING AND CALLS COMPONENT -->
                        <!-- <meeting-and-calls :lead.sync="current_lead"></meeting-and-calls> -->
                    </b-col>
                    <b-col cols="12" lg="6">
                        <el-tabs
                        v-model="current_tab"
                        @tab-click="handleTabClick"
                        >
                            <el-tab-pane label="Overview" name="overview" :lazy="true">
                                <activity-log :lead="current_lead"></activity-log>
                            </el-tab-pane>
                            <el-tab-pane label="Documents" name="documents" :lazy="true" v-if="checkAccess(['l_lead_attachment__listing']) || auth_user.subscription.privileges.scpk_cus_document_upload">
                                <documents
                                    :base_url="services.lead + 'lead/' + $route.params.lead_id +'/attachments'"
                                ></documents>
                            </el-tab-pane>
                        </el-tabs>
                    </b-col>
                    <b-col cols="12" lg="3">
                        <Remark :base_url="services.lead + 'lead/'+$route.params.lead_id+'/remarks'" type='lead'/>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <LoadingPage :is_loading="is_loading_page"/>
    </div>
</template>
<script>
    import { Dropdown, DropdownMenu, DropdownItem, Link, Tabs, TabPane } from 'element-ui'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import LeadsBiodata from '@/views/Leads/LeadsProfile/LeftProfileDetails/LeadsBiodata'
    import LeadLookingFor from '@/views/Leads/LeadsProfile/LeftProfileDetails/LeadLookingFor'
    import MeetingAndCalls from '@/views/Leads/LeadsProfile/LeftProfileDetails/MeetingAndCalls'
    import ActivityLog from '@/views/Leads/LeadsProfile/CenterProfileDetails/ActivityLog'
    import Remark from '@/components/Remark'
    import { mapActions, mapState } from 'pinia'
    import { useLeadStore } from '@/stores/leadStore'
    import Documents from '@/components/Documents'
    import {services} from '@/assets/js/config.js'
    import AssignLeadsToModalVue from '@/views/Leads/Modal/AssignLeadsToModal'
    import LoadingPage from '@/components/LoadingPage'
    import { 
    helperFunctionMixin,
    } from '@/assets/js/httpImports.js'

    export default {
        mixins:[
            helperFunctionMixin
        ],
        components: {
            LeadLookingFor,
            LoadingPage,
            // RouteBreadCrumb,
            LeadsBiodata,
            ActivityLog,
            Remark,
            // MeetingAndCalls,
            Documents,
            AssignLeadsToModalVue,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Link.name]: Link,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
        },
        data() {
            return {
                is_loading_page:false,
                modals: {
                    assign_lead : false
                },
                lead: null,
                backButton: true,
                current_tab: 'overview',
                services:services,
                lead_data: [],
                assign_to_name: "",
            };
        },
        watch: {
            '$route.query.active': {
            handler(newValue, oldValue) {
                this.current_tab = newValue 
            },
            immediate: true
            },
        },
        computed: {
            ...mapState(useLeadStore,['current_lead', 'listing_current_page']),
        },
        async created(){
            this.is_loading_page = true
            await this.getLead(this.$route.params.lead_id)

            if(!this.current_lead){
                this.$router.push({ name: 'NotFound' })
            }

            //check active tabs
            if(this.$route.query.active){
                this.current_tab = this.$route.query.active.toLowerCase() 
            }else{
                const query = { ...this.$route.query, active: 'overview' };
                this.$router.push({path: this.$route.path, query});
            }
            this.is_loading_page = false
        },
        methods: {
            ...mapActions(useLeadStore,['getLead', 'resetLeadStore']),
            handleTabClick(obj, e){
                if(this.$route.query.active !== obj.name){
                    const query = { ...this.$route.query, active: obj.name };
                    this.$router.push({path: this.$route.path, query});
                }
            },
            close() {
                this.$router.back();
            },
            toggleAssignModal(lead_data,assign_to_name){
                if(!this.checkIsCorporateSubscription()){
                    return
                }
                if(!this.modals.assign_lead){
                    this.lead_data = []
                    this.lead_data.push(lead_data)
                    this.lead_data['assign_type'] = 1
                }else{
                    this.getLead(this.$route.params.lead_id)
                }
                this.modals.assign_lead = !this.modals.assign_lead
            },
        },
        destroyed(){
            this.resetLeadStore()
        },
    }
</script>